import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {MarcheTemporaliComponent} from './marche_temporali';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('home.marche-temporali', {
            url: '/marche-temporali',
            ncyBreadcrumb: {
                label: 'marche-temporali',
                parent: 'home.admin'
            },
            data: {
                authorisationLevel: 2,
                pageTitle: 'marche-temporali'
            },
            'views': {
                'homeContent': {
                    template: '<marche-temporali flex="100"></marche-temporali>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const MarcheTemporaliModule: string = ng
    .module('marche-temporali', [
        'ui.bootstrap',
        uiRouter,
    ])
    .component('marcheTemporali', MarcheTemporaliComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/marche_temporali/marche_temporali.module.ts